import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
const FEATURED_LIFESTYLE_IMAGE = 'https://cdn.magicpatterns.com/uploads/qWzJg8XrrEtx2kiptqiBZM/image.png';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="testimonios" className="py-20 lg:py-28 bg-brand-cream" data-id="element-263">
      <div className="container mx-auto px-6" data-id="element-264">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-265">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-266">
            {t('testimonials.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-267">
            {t('testimonials.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-268">
            {t('testimonials.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-269"></div>
        </div>

        {/* FEATURED EDITORIAL BANNER — aspirational lifestyle */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.1,
        ease: easeOutCubic
      }} className="relative rounded-[2rem] overflow-hidden max-w-6xl mx-auto" data-id="element-270">
          <div className="relative aspect-[16/9] md:aspect-[21/9]" data-id="element-271">
            <img src={FEATURED_LIFESTYLE_IMAGE} alt="DermaLipo Phoenix — real patient silhouette" className="absolute inset-0 w-full h-full object-cover" data-id="element-272" />
            {/* Soft warm gradient from left → so text reads cleanly */}
            <div className="absolute inset-0 bg-gradient-to-r from-brand-cream/95 via-brand-cream/60 to-transparent" data-id="element-273"></div>
            <div className="absolute inset-0 bg-grain opacity-30 pointer-events-none mix-blend-multiply" data-id="element-274"></div>
          </div>

          {/* Overlay editorial copy */}
          <div className="absolute inset-0 flex items-center" data-id="element-275">
            <div className="px-8 md:px-16 max-w-md" data-id="element-276">
              <div className="inline-flex items-center gap-3 mb-5" data-id="element-277">
                <span className="w-8 h-px bg-brand-gold" data-id="element-278"></span>
                <span className="text-brand-dark/60 font-medium tracking-[0.25em] text-[10px] uppercase" data-id="element-279">
                  {t('testimonials.bannerTag')}
                </span>
              </div>
              <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl text-brand-dark font-light leading-tight mb-6" data-id="element-280">
                "{t('testimonials.bannerQuote')}"
              </p>
              <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50" data-id="element-281">
                {t('testimonials.bannerAttribution')}
              </p>
            </div>
          </div>
        </motion.div>

        {/* Privacy note + CTA */}
        <div className="text-center mt-20 max-w-2xl mx-auto" data-id="element-282">
          <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/30 mb-10" data-id="element-283">
            {t('testimonials.privacyNote')}
          </p>
          <button onClick={scrollToContact} className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-dark border-b border-brand-gold/60 hover:border-brand-gold pb-2 transition-colors" data-id="element-284">
            {t('nav.cta')} →
          </button>
        </div>
      </div>
    </section>;
}